import React,{useState, useCallback, useEffect} from 'react';
import {BrowserRouter, Route, Switch} from 'react-router-dom'//yarn add @types/react-router-dom
import {MuiThemeProvider} from '@material-ui/core/styles';
import Header from './Header';
import Main from "./Main";
import Enter from "./Enter";
import News from './News';
import Guide from './Guide';
import Dict from './Dict';
import Ajax from './Ajax';
import Loading from './Loading';
import {Styles} from './Styles';
import {Theme} from './Theme';

let storageKey = "retrogannen";

const App: React.FC = () => {
  const basename = process.env.REACT_APP_BASENAME;
  const classes = Styles.base();

  const [userId,setUserId] = useState("")

	const save= (id:string)=>{
		const json = {
			"userId": id,
		};
    window.localStorage.setItem(storageKey,JSON.stringify(json));
    setUserId(id);
	};
	const load=useCallback(()=>{
    const value = window.localStorage.getItem(storageKey);
		if( value ){
			const json = JSON.parse(value);
			if( json.userId && json.userId!=="" ){
				setUserId(json.userId);
				return true;
			}
		}
		Ajax.send("user/new",{},(res:any)=>{
      //console.log(res);
			if( res.ok ){
        save(res.user_id);
			}
		});
		return false;
  },[]);
  const config = ()=>{
		Ajax.send("config",{},(res:any)=>{
      //console.log(res);
			if( res.ok ){
        
			}
		});
  }

  useEffect( ()=>{
    //config();
    load();
  },[load]);
  
  let isLoading = false;
  if( userId==="" ){
    isLoading = true;
  }

  return (
    <BrowserRouter basename={basename}>
      <MuiThemeProvider theme={Theme}>
        {userId!=="" &&
        <div className={classes.App}>
          <Header userId={userId}/>
          <Switch>
            <Route exact path='/' render={()=><Main userId={userId}/>}/>
            <Route exact path='/news' render={()=><News userId={userId}/>}/>
            <Route exact path='/guide' render={()=><Guide/>}/>
            <Route exact path='/dict' render={()=><Dict/>}/>
            <Route exact path='/:gid' render={()=><Enter userId={userId}/>}/>
          </Switch>
        </div>
        }
        <Loading isLoading={isLoading}/>
      </MuiThemeProvider>
    </BrowserRouter>
  );
}

export default App;
